import styled from 'styled-components';
import { spacing, positioning } from 'ui/theme/utils';

import device from 'ui/theme/device';

export default styled.div`
  font-size: 14px;
  @media ${device.small} {
    font-size: 12px;
  }

  ${({ fontSize }) => fontSize && `font-size: ${fontSize};`}
  ${({ lineHeight }) => lineHeight && `line-height: ${lineHeight};`}

  ${(props) => `
    ${spacing(props)}
    ${positioning(props)}
  `}
`;
